module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.2d0bdc8d.ttf";